import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import CustomerService from "../services/CustomerService";
import {useAppDispatch} from "../store";
import {changeUser} from "../store/slice/auth";

function LogoutPage() {

    const [ errorMessage, setErrorMessage ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState(false);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();


    const doLogout = ()=>  {

        setLoading(true);
        setErrorMessage(null);

        CustomerService.logout()
            .then((/*response*/) => {
                dispatch(changeUser(null));
                navigate({pathname: '/login'});
            })
            .catch((/*error*/) => {
                setLoading(false);
                setErrorMessage('An unexpected error occurred')
            });
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-6 col-sm-12">

                    <h1 className="h3 p-3 font-weight-normal text-center">Sign Out?</h1>

                    {errorMessage &&
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    }

                    <div className="d-grid gap-2">
                        <button className="btn btn-lg btn-primary" type="button" disabled={loading} onClick={doLogout}>
                            {loading && <span className="spinner-border float-start" role="status" aria-hidden="true" />}
                            {loading ? 'Signing out...' : 'Sign out' }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default LogoutPage;
